import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { Tips } from '../../../../types/fam-graphql'

const query = gql`
  query getOnboardingTips {
    getOnboardingTips {
      course_composition
      course_range
      diet_practice
      dried_vegetables_frequency
      drink_frequency
      express
      fish_frequency
      fruits_vegetables_quantity
      meat_frequency
      medium
      medium_title
      minium
      minium_title
      optimal
      optimal_title
      people_count
      starchy_foods_frequency
    }
  }
`

const transformer = ({
  getOnboardingTips,
}: {
  getOnboardingTips: Tips
}): Tips => getOnboardingTips

export default queryServiceCreator(query, transformer)
